import { XcoreError } from "./XcoreError";

export class AuthError extends XcoreError {
  public name: "AuthError" = "AuthError" as const;

  public response: Response;

  constructor(url: string, res: Response) {
    super(url, `Request failed due to authentication error: ${res.statusText} (${res.status})`);
    this.response = res;
  }
}
